"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamSubscriptionCapability = void 0;
var TeamSubscriptionCapability;
(function (TeamSubscriptionCapability) {
    TeamSubscriptionCapability["UNKNOWN"] = "unknown";
    TeamSubscriptionCapability["QUOTA_MB_0"] = "quota_mb_0";
    TeamSubscriptionCapability["QUOTA_MB_100"] = "quota_mb_100";
    TeamSubscriptionCapability["QUOTA_MB_200"] = "quota_mb_200";
    TeamSubscriptionCapability["QUOTA_MB_500"] = "quota_mb_500";
    TeamSubscriptionCapability["QUOTA_MB_1_000"] = "quota_mb_1_000";
    TeamSubscriptionCapability["QUOTA_MB_99_000"] = "quota_mb_99_000";
    TeamSubscriptionCapability["QUOTA_MB_129_000"] = "quota_mb_129_000";
    TeamSubscriptionCapability["QUOTA_MB_140_000"] = "quota_mb_140_000";
    TeamSubscriptionCapability["ROSTER_LIMIT_15"] = "roster_limit_15";
    TeamSubscriptionCapability["ROSTER_LIMIT_20"] = "roster_limit_20";
    TeamSubscriptionCapability["ROSTER_LIMIT_30"] = "roster_limit_30";
    TeamSubscriptionCapability["ROSTER_LIMIT_40"] = "roster_limit_40";
    TeamSubscriptionCapability["ROSTER_LIMIT_150"] = "roster_limit_150";
    TeamSubscriptionCapability["ROSTER_LIMIT_4_000"] = "roster_limit_4_000";
    TeamSubscriptionCapability["TSL"] = "tsl";
    TeamSubscriptionCapability["TEAM_CHAT"] = "team_chat";
    TeamSubscriptionCapability["AD_FREE"] = "ad_free";
    TeamSubscriptionCapability["ASSIGNMENTS"] = "assignments";
    TeamSubscriptionCapability["AVAILABILITY_EXPORT"] = "availability_export";
    TeamSubscriptionCapability["CLUBS"] = "clubs";
    TeamSubscriptionCapability["CUSTOM_DOMAIN"] = "custom_domain";
    TeamSubscriptionCapability["CUSTOM_FIELDS"] = "custom_fields";
    TeamSubscriptionCapability["EVENT_LINEUP"] = "event_lineup";
    TeamSubscriptionCapability["EXTERNAL_EMAIL"] = "external_email";
    TeamSubscriptionCapability["HIDE_MARKETPLACE_TAB"] = "hide_marketplace_tab";
    TeamSubscriptionCapability["MESSAGES"] = "messages";
    TeamSubscriptionCapability["OFF_SEASON"] = "off_season";
    TeamSubscriptionCapability["PAYMENTS"] = "payments";
    TeamSubscriptionCapability["PAYPAL"] = "paypal";
    TeamSubscriptionCapability["PHOTOS"] = "photos";
    TeamSubscriptionCapability["PLAYER_AVAILABILITY"] = "player_availability";
    TeamSubscriptionCapability["REFRESHMENTS"] = "refreshments";
    TeamSubscriptionCapability["ROSTER_PHOTOS"] = "roster_photos";
    TeamSubscriptionCapability["RSS"] = "rss";
    TeamSubscriptionCapability["SEASONS"] = "seasons";
    TeamSubscriptionCapability["SPONSORSHIPS"] = "sponsorships";
    TeamSubscriptionCapability["SSL_SECURITY"] = "ssl_security";
    TeamSubscriptionCapability["STATISTICS"] = "statistics";
    TeamSubscriptionCapability["TEAM_COLORS"] = "team_colors";
    TeamSubscriptionCapability["TEAM_LOGO"] = "team_logo";
    TeamSubscriptionCapability["TEXT_MESSAGING"] = "text_messaging";
    TeamSubscriptionCapability["TRACKING"] = "tracking";
    TeamSubscriptionCapability["WEATHER"] = "weather";
})(TeamSubscriptionCapability || (exports.TeamSubscriptionCapability = TeamSubscriptionCapability = {}));
